module.exports = __webpack_public_path__ + "img/post_pic2.c1ba476f.png";